(() => {
  const cards = [...document.querySelectorAll('[data-demo-card]')];
  cards.forEach(card => {
    const video = card.querySelector('video');
    const start = card.querySelector('[data-demo-start]');
    const status = card.querySelector('[data-demo-status]');
    if (!video || !start) return;
    start.hidden = false;
    start.addEventListener('click', async () => {
      status.textContent = '';
      try { await video.play(); } catch (_) {
        start.hidden = false;
        status.textContent = 'Tap the video controls to play.';
      }
    });
    video.addEventListener('play', () => {
      start.hidden = true;
      cards.forEach(other => { const media = other.querySelector('video'); if (media !== video) media.pause(); });
    });
    video.addEventListener('error', () => {
      start.hidden = true;
      status.textContent = 'Video could not load. Please refresh and try again.';
    });
  });
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (!entry.isIntersecting) entry.target.pause(); });
    }, { threshold: 0.05 });
    cards.forEach(card => observer.observe(card.querySelector('video')));
  }
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) cards.forEach(card => card.querySelector('video').pause());
  });
})();
